import GamePointsSettings from "../Models/GamePointsSettings";
import HttpService from "../Services/HttpService";

export class GameRepository
{
  public gamePointsSettings: GamePointsSettings = {
    gameScores: [],
  };

  public async getGamePoints(): Promise<GamePointsSettings>
  {
    const url = '/Game/Points';
    this.gamePointsSettings = await HttpService.get<GamePointsSettings>(url);
    return this.gamePointsSettings;
  }

  public async updateGamePoints(request: GamePointsSettings): Promise<GamePointsSettings>
  {
    const url = '/Game/Points';
    this.gamePointsSettings = await HttpService.put<GamePointsSettings>(url, request);
    return this.gamePointsSettings;
  }
}

export const gameRepository = new GameRepository();